import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// Reducers
import * as fromAuth from '../../auth/reducers';
import * as fromCore from '../reducers';
import * as fromProject from '../../project/reducers';

// Actions
import * as Auth from '../../auth/actions/auth.actions';
import * as UIActions from '../actions/ui.actions';

// Services
import { RolesAndPermissionsService } from './roles-and-permissions-setup.service';
import { ProjectService } from '../../project/services/project.service';

@Injectable()
export class RolesGuard implements CanActivate {

  // Constructor
  constructor(
    private roleService: RolesAndPermissionsService,
    private projectService: ProjectService,
    private router: Router,
    private store: Store<fromAuth.State>,
    private coreStore: Store<fromCore.State>,
  ) {}

  // Can Activate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const routeRoles = route.data['roles'] as Array<number>;
    const projectID = route.pathFromRoot.find(path => path.params.projectID).params.projectID;

    return this.projectService.getCurrentUserRolesAndPermissions({ project_id: projectID }).map((data: any) => {
        if (this.roleService.includesUserRole(data.data, routeRoles))
          return true;
        else {
          this.coreStore.dispatch(new UIActions.ProjectView(false));
          this.store.dispatch(new Auth.DashboardRedirect());
          return false;
        }
      })
      .take(1);
  }
}

@Injectable()
export class UserPermissionsGuard implements CanActivate {

  // Constructor
  constructor(
    private roleService: RolesAndPermissionsService,
    private projectService: ProjectService,
    private router: Router,
    private store: Store<fromAuth.State>,
    private coreStore: Store<fromCore.State>,
    private projectStore: Store<fromProject.State>
  ) {}

  // Can Activate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const role = route.data['role'] as number;
    const permission = route.data['permission'] as string;
    const projectID = route.pathFromRoot.find(path => path.params.projectID).params.projectID;

    return this.projectService.getCurrentUserRolesAndPermissions({ project_id: projectID }).map((data: any) => {
        if (this.roleService.hasPermission(data.data, role, permission))
          return true;
        else {
          this.coreStore.dispatch(new UIActions.ProjectView(false));
          this.store.dispatch(new Auth.DashboardRedirect());
          return false;
        }
      })
      .take(1);
  }
}

@Injectable()
export class ProjectSettingsGuard implements CanActivate {
  // Constructor
  constructor(
    private projectService: ProjectService,
    private router: Router,
    private store: Store<fromAuth.State>,
    private coreStore: Store<fromCore.State>
  ) {}

  // Can Activate
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const blockProjectSettings = route.data['blockProjectSettings'] as Array<any>;
    const projectID = route.pathFromRoot.find(path => path.params.projectID).params.projectID;

    return this.projectService.getProjectSettings({ project_id: projectID }).map((data: any) => {
      const block = blockProjectSettings.filter(setting => data.data[setting.id] === setting.value);

      if (!block.length)
        return true;
      else {
        this.coreStore.dispatch(new UIActions.ProjectView(false));
        this.store.dispatch(new Auth.DashboardRedirect());
        return false;
      }
    })
    .take(1);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/project-setup.guard.ts